import React from 'react';
import { FaStar } from 'react-icons/fa';

const StarsThree = ({ isEven, isStarColor, numStars }) => {
  const totalStars = 3;
  const yellowStars = numStars;
  const whiteStars = totalStars - yellowStars;

  return (
    <div className={`stars-three ${isEven ? 'stars-three-left' : 'stars-three-right'}`}>
      {[...Array(yellowStars)].map((_, index) => (
        <span key={`yellow-${index}`} className={`star-inner inner-star-${index + 1}`}>
          <FaStar size={30} className="yellow-color" />
        </span>
      ))}

      {[...Array(whiteStars)].map((_, index) => (
        <span key={`white-${index}`} className={`star-inner inner-star-${yellowStars + index + 1}`}>
          <FaStar size={30} className="white-color" />
        </span>
      ))}
    </div>
  );
};

export default StarsThree;
